import React, { useCallback, useEffect, useState } from "react";

import { getAllAdminMethods, getFundingOpportunities } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, Col, MainPage, Row } from "components";

export const FundingList = () => {
  const [fundingOpportunities, setFundingOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const signal = useCancelAsyncOnUnmount()();

  const loadFundingOpportunites = useCallback(() => {
    getAllAdminMethods({
      signal,
    })
      .then((methodsResponse) => {
        getFundingOpportunities({
          signal,
        }).then((fundingResponse) => {
          const fundingOpps = [];
          const fundingOppsArr = [...fundingResponse];
          for (const fundingOpp of fundingOppsArr) {
            const methodsArr = fundingOpp.methods.map((methodId) => {
              const foundMethod = methodsResponse.find((method) => method.id === methodId);
              return foundMethod.title;
            });
            fundingOpps.push({ ...fundingOpp, methods: methodsArr });
          }
          setFundingOpportunities(fundingOpps);
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadFundingOpportunites();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${fundingOpportunities.length} funding opportunities`}
        description="View, add or update funding opportunities here."
        extra={
          <Button size="small" type="secondary" href="/funding/add">
            Add
          </Button>
        }
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={fundingOpportunities}
            config={{
              exclude: ["conditions", "fundingAmount", "fundingAmountExplainer", "link", "linkText"],
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/funding/update/",
                  tooltip: "Edit this funding opportunity",
                },
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
